var React = require('react');

function IcProfile (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ic_profile","transform":"translate(1)"},[React.createElement("g",{"id":"Ellipse_68","data-name":"Ellipse 68","transform":"translate(11.138)","fill":"none","stroke":"currentColor","strokeWidth":"2","key":0},[React.createElement("circle",{"cx":"12.171","cy":"12.171","r":"12.171","stroke":"none","key":0}),React.createElement("circle",{"cx":"12.171","cy":"12.171","r":"11.171","fill":"none","key":1})]),React.createElement("path",{"id":"Path_684","data-name":"Path 684","d":"M46.811,36.406A23.405,23.405,0,1,0,0,36.406","transform":"translate(0 10.338)","fill":"none","stroke":"currentColor","strokeWidth":"2","key":1})]));
}

IcProfile.defaultProps = {"width":"48.811","height":"46.744","viewBox":"0 0 48.811 46.744"};

module.exports = IcProfile;

IcProfile.default = IcProfile;
